// 커스텀 필터 함수를 정의한다.
export default (value) => {
  if (!value) return ''
  // 문자열 데이터 포맷(YY.MM.DD)으로 변경한다.
  return value.substr(2, 8).replace(/-/gi, '.')
}
